import React, { Fragment, memo, ReactNode } from 'react';

export const RESTRICTED_PLACEHOLDER = '----- (Restricted)';

export interface RestrictedValueProps {
  /** When true, render the placeholder instead of the children. */
  restricted: boolean;
  children?: ReactNode;
}

/**
 * Renders its children normally, or a neutral placeholder when the value is
 * restricted. Display only — it does not prevent the value reaching the client.
 */
export const RestrictedValue = memo((props: RestrictedValueProps) => {
  if (props.restricted) {
    return <span className="text-muted font-italic">{RESTRICTED_PLACEHOLDER}</span>;
  }
  return <Fragment>{props.children}</Fragment>;
});
